import React, { createRef, useCallback, useEffect, useRef, useState } from "react";
import classNames from "classnames";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import Icon from "../../../elements/icon";
import Videojs from "../../video-js";
import Image from "../../../elements/image";
import { mobileIs } from "../../../utils/siteUtils";

import "./style.scss";
let count = 0
const CoclubSwiperSlide = props => {
  const videoEl = useRef(null);
  const timer = useRef(null);
  const isMobile = mobileIs()
  const [hovered,setHovered] = useState(false);
  let { index, previousIndex, length, modelShow } = props;
  let { video, videoMobile, image, imageMobile, title, titleMobile, titleIcon, content, contentMobile, iconName, iconNameMobile } = props.slides.fields;
  const videoHover = () => {
    if(videoEl && videoEl.current && !isMobile){
      if(!isMobile){
        setHovered(true)
        document.getElementById('video'+index).classList.add("vjs-has-started")
      }
      setTimeout(v=>{
        videoEl.current.player.play()
      },20)
    }
  }
  const videoLeave = (number) => {
    if(videoEl && videoEl.current && !modelShow){
      clearTimeout(timer.current)
      timer.current = setTimeout(v=>{
        if(isMobile){
          if(number){
            editClass('video'+number, 'remove')
          }else{
            editClass('video'+index, 'remove')
          }
        }else{
          document.getElementById('video'+index).classList.remove("vjs-has-started")
          setHovered(false)
        }
        videoEl.current.player.pause()
        videoEl.current.player.currentTime(0)
        videoEl.current.player.trigger('loadstart')
      },100)
    }
  }
  const videoPlay = (e) => {
    props.videoPlay && props.videoPlay();
    e.preventDefault();
    e.stopPropagation();
    videoEl.current.player.play()
    editClass('video'+index, 'add')
  }
  const editClass = (name, type) => {
    var alist = document.getElementsByClassName(name);
    if (alist){
      for ( var  idx = 0; idx < alist.length; idx ++){
        var  mya = alist[idx];
        if(type === 'add'){
          mya.getElementsByClassName('video-js')[0].classList.add("vjs-has-started")
        } else {
          mya.getElementsByClassName('video-js')[0].classList.remove("vjs-has-started")
        }
      }
    };
  }
  const itemLoader = () => {
    props.itemLoader && props.itemLoader(props.slides.id);
  }
  const showModel = () => {
    videoLeave()
    props.onClick && props.onClick();
  }
  const videoOptions =
  (( !isMobile && video && video.value) || ( isMobile && videoMobile && videoMobile.value))
    ? {
        sources: [
          {
            src: isMobile ? videoMobile.value.src : video.value.src,
            type: isMobile ? videoMobile.value.mimeType : video.value.mimeType
          }
        ],
        poster: isMobile ? imageMobile.value.src : image.value.src,
        videoTitle: '',
        autoplay: false,
        controls: false,
        muted: true
      }
    : null;
    useEffect(() => {
      if(isMobile){
        if(previousIndex==length+1){
          if(videoEl&&videoEl.current){
            videoLeave(length-1)
          }
        }else if(previousIndex==0){
          if(videoEl&&videoEl.current){
            videoLeave(0)
          }
        } else if (previousIndex==index+1){
          if(videoEl&&videoEl.current){
            videoLeave(index)
          }
        }
      }
    }, [previousIndex]);  

  return (
    <div className="coclub-swiper-slide-content" onMouseOver={videoHover} onMouseLeave={videoLeave}>
      <div className="coclub-swiper-slide-content-media" onClick={showModel}>
			  { !videoOptions && 
        <Image className="coclub-swiper-slide-img" {...isMobile ? imageMobile.value : image.value} handleLoad={itemLoader}/>
        }
        { videoOptions &&
          <div className={classNames("coclub-swiper-slide-video",'video'+index,{hovered:hovered})}>
            <Videojs ref={videoEl} id={'video'+index} {...videoOptions} videoLoaded={itemLoader} />
            <Image className="coclub-swiper-slide-imgVideo" {...isMobile ? imageMobile.value : image.value} />
            <div className="playBtn" onClick={e=>{videoPlay(e)}}></div>
          </div>
        }
      </div>
      <div className="grid coclub-swiper-slide-content-grid">
        <div className="coclub-swiper-slide-detail">
          { ((isMobile && titleMobile.value) || (!isMobile && title.value)) &&
          <div className="coclub-swiper-slide-title">
            <RichText field={ isMobile ? titleMobile : title } />
            <span>{titleIcon.value}</span>
          
          </div>
          }
          { ((isMobile && contentMobile.value) || (!isMobile && content.value)) &&
            <RichText className="coclub-swiper-slide-des" field={ isMobile ? contentMobile : content} />
          }
          {<Image className="iconName pcs" {...iconName.value} />}
          {<Icon className="phs" icon={iconNameMobile.value } onClick={showModel} />}
        </div>
      </div>
    </div>
  );

}
export default CoclubSwiperSlide;
